module.exports = __webpack_public_path__ + "public/images/overview/Mohov.3e75ea86a2b1e87cfecb69096185ba81.png";